import './ComingSoon.css';

export default function ComingSoon() {
  return (
    <div className="page-wrapper">

      {/* HEADER */}
      {/* <header className="header">
        <div className="header-inner">
          <span className="brand-name">Anvaya Industries</span>
          <nav className="nav-items">
            <span className="nav-item">Innovation</span>
            <span className="nav-item">Precision</span>
            <span className="nav-item">Integrity</span>
          </nav>
        </div>
      </header> */}

      {/* MAIN */}
      <main className="main">
        <div className="blob blob-1" />
        <div className="blob blob-2" />

        <div className="content-wrap">
          {/* Welcome */}
          <h1 className="welcome-text">Welcome to</h1>

          {/* Logo */}
          <div className="logo-wrap">
            <img
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuBVTZhl_19vBBEVjcWGheUFHxkP8kNG-6RALf8DFS8PN_p1mCBTIANGwAZUtJ4UN0SoiMDLEw-qG0JdhESYRLKs5AwplAoZY1wgyEPST--E5A5xeybymm6F1uqMJgZQn4h2NgT46GSvCGT16WbR1BpGzZlUggs4wNbRVv-ZubBhnIkXNjy4ijHrrK0sxyuUf1mtj2ArXoYZG9RXQ0pX651PLtXiYgBAklsntN3GGJmuDx3_hwSXjQ6YeY_-k9adPUB-NVfao4QgPCQ"
              alt="Anvaya Industries Logo"
              className="logo-img"
            />
          </div>

          {/* Coming Soon */}
          <h2 className="coming-soon-headline">WE ARE COMING SOON..</h2>

          {/* Card */}
          {/* <div className="info-card">
            <div className="card-accent" />
            <p className="card-body">
              Our digital platform is currently under high-precision engineering.
              We are building the next generation of industrial solutions designed
              for reliability and technical excellence.
            </p>
            <div className="btn-row">
              <button className="btn btn-primary">
                <span className="material-symbols-outlined">notifications</span>
                NOTIFY ME
              </button>
              <button className="btn btn-secondary">OUR VISION</button>
            </div>
          </div> */}
        </div>
      </main>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <span className="footer-brand-name">Anvaya Industries</span>
            <p className="footer-tagline">DRIVING INNOVATION.</p>
          </div>
          <div className="footer-contact">
            <div className="contact-item">
              <span className="material-symbols-outlined">call</span>
              <span>Phone: +91 9350737235</span>
            </div>
            <div className="contact-item">
              <span className="material-symbols-outlined">mail</span>
              <span>Email: amit@anvayain.org</span>
            </div>
          </div>
          <div className="footer-copy">
            © 2026 Anvaya Industries. All rights reserved.
          </div>
        </div>
      </footer>

    </div>
  );
}
